import React from "react";
import { Button, Container } from "react-bootstrap";
import { FaArrowLeft, FaHome } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getStoredToken } from "../utils/auth";

const adminPrefixes = [
  "/dashboard",
  "/news-admin",
  "/job-admin",
  "/contact-admin",
];

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPath = adminPrefixes.some((path) =>
    location.pathname.startsWith(path)
  );
  const homePath = isAdminPath && getStoredToken() ? "/dashboard" : "/";

  return (
    <Container fluid className="not-found-page p-0">
      <div className="not-found-panel text-center">
        <p className="not-found-eyebrow mb-2">404 error</p>
        <h1 className="not-found-title mb-3">Page not found</h1>
        <p className="not-found-copy mb-4">
          Halaman yang kamu buka tidak tersedia atau URL-nya tidak sesuai dengan
          route aplikasi.
        </p>
        <div className="d-flex flex-wrap justify-content-center gap-3">
          <Button
            type="button"
            variant="outline-secondary"
            className="not-found-back-btn d-inline-flex align-items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft />
            Kembali
          </Button>
          <Button
            as={Link}
            to={homePath}
            className="not-found-home-btn d-inline-flex align-items-center gap-2"
          >
            <FaHome />
            {isAdminPath ? "Dashboard" : "Home"}
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default NotFound;
